import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_german-bizleads/artifacts/tvr4e56b_2.png" 
              alt="Adloc Logo" 
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-400">
              Deutschlands vollständigste B2B-Kontaktdatenbank
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Rechtliches</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => navigate('/impressum')}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Impressum
                </button>
              </li>
              <li>
                <button
                  onClick={() => navigate('/datenschutz')}
                  className="text-gray-400 hover:text-white transition-colors duration-200"
                >
                  Datenschutz
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4">Kontakt</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a 
                  href="mailto:kontakt@adloc.io" 
                  className="hover:text-white transition-colors duration-200"
                >
                  kontakt@adloc.io
                </a>
              </li>
              <li>
                <button
                  onClick={() => navigate('/app')}
                  className="hover:text-white transition-colors duration-200"
                >
                  Zur Anwendung
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} Adloc. Alle Rechte vorbehalten.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;